/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-empty-pattern */
import { useEffect, useState, useRef, useCallback } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Ref, Button, Segment, Modal } from "semantic-ui-react";
import { TextField } from "@mui/material";
import { selectCurrentUserApiToken, selectCurrentUserM11Use } from "../../slices/currentUser/currentUserSlice";
import { goToM11Step, m11ResearchStudyFoiChanged, m11StepCountDown, m11StepCountUp, selectM11ResearchStudyFoi, selectM11StepCount } from "../../slices/m11StepCount/m11StepCountSlice";
import { changeTool } from "../../slices/footer/footerSlice";
import getFhirJson from "../../functions/getFhirJsonAPI";
import { validateStep } from "../../functions/validateM11ReportAPI";
import { handleWheel, handleRememberScroll } from "../../functions/eventHandlers";
import AlertModal from "../../components/AlertModal";
import FeedbackButton from "../../components/FeedbackButton";
import { m11HelperTextListLength } from "../../components/M11HelperText";
import M11Step001SponsorDetails from "./M11Step001SponsorDetails";
import M11Step002Identifiers from "./M11Step002Identifiers";
import M11Step003TitlePageData from "./M11Step003TitlePageData";
import M11Step006Eligibility from "./M11Step006Eligibility";
import M11Step008FirstPrimaryObjective from "./M11Step008FirstPrimaryObjective";
import M11Step011ExploratoryObjectives from "./M11Step011ExploratoryObjectives";
import M11Step004Amendment from "./M11Step004Amendment";
import { setM11useToPaid } from "./M11ReportPage";
import M11Step005CreateTitlePage from "./M11Step005CreateTitlePage";
import M11Step015ProtocolSynopsisObjectives from "./M11Step015ProtocolSynopsisObjectives";
import M11Step013EnterOverallDesign from "./M11Step013EnterOverallDesignData";
import M11Step014EnterOverallDesign2 from "./M11Step014EnterOverallDesignData2";
import M11Step016OverallDesign from "./M11Step016OverallDesign";
import M11Step017ProtocolSynopsis from "./M11Step017ProtocolSynopsis";
import M11Step018ProtocolSummary from "./M11Step018ProtocolSummary";
import M11Step019Introduction from "./M11Step019Introduction";
import M11Step012ObjectivesAndEstimands from "./M11Step012ObjectivesAndEstimands";
import M11Step020TrialDesign from "./M11Step020TrialDesign";
import M11Step007TrialPopulation from "./M11Step007TrialPopulation";
import M11Step021TrialInterventionPart1 from "./M11Step021TrialInterventionPart1";
import M11Step022TrialInterventionPart2 from "./M11Step022TrialInterventionPart2";
import M11Step023TrialInterventionPart3 from "./M11Step023TrialInterventionPart3";
import M11Step024TrialInterventionPart4 from "./M11Step024TrialInterventionPart4";
import M11Step025TrialInterventionPart5 from "./M11Step025TrialInterventionPart5";
import M11Step026ParticipantDiscontinuation from "./M11Step026ParticipantDiscontinuation";
import M11Step027TrialAssessmentsPart1 from "./M11Step027TrialAssessmentsPart1";
import M11Step028TrialAssessmentsPart2 from "./M11Step028TrialAssessmentsPart2";
import M11Step029TrialAssessmentsPart3 from "./M11Step029TrialAssessmentsPart3";
import getIdFromReference from "../../functions/getIdFromReference";
import { m11ReportCollectionLoaded, selectM11ResearchStudyResource } from "../../slices/m11ReportAuthoringTool/m11ReportAuthoringToolSlice";
import M11Step030AdverseEventsDefinitions from "./M11Step030AdverseEventsDefinitions";
import M11Step031AdverseEventsProcedures from "./M11Step031AdverseEventsProcedures";
import M11Step032CompleteAdverseEvents from "./M11Step032CompleteAdverseEvents";
import M11Step033StatisticsPart1 from "./M11Step033StatisticsPart1";
import M11Step010SecondaryObjectives from "./M11Step010SecondaryObjectives";
import M11Step034CompleteStatistics from "./M11Step034CompleteStatistics";
import M11Step035TrialOversightPart1 from "./M11Step035TrialOversightPart1";
import M11Step036TrialOversightPart2 from "./M11Step036TrialOversightPart2";
import M11Step037CompleteTrialOversight from "./M11Step037CompleteTrialOversight";
import M11Step038GatherAppendices from "./M11Step038GatherAppendices";
import M11Step039Glossary from "./M11Step039Glossary";
import M11Step040References from "./M11Step040References";
import M11Step041SupportingDetailsPart1 from "./M11Step041SupportingDetailsPart1";
import M11Step042PriorProtocolAmendments from "./M11Step042PriorProtocolAmendments";
import M11Step043AdditionalAppendices from "./M11Step043AddittionalAppendices";
import M11ValidationModal from "./M11ValidationModal";
import M11Step044ReportValidation from "./M11Step044ReportValidation";
import M11Step009OtherPrimaryObjectives from "./M11Step009OtherPrimaryObjectives";
import M11Step045CreateM11Report from "./M11Step045CreateM11Report";
import Spinner from "../../components/Spinner";

const fetchTheSet = async (theM11ResearchStudyFoi, dispatch, apiToken) => {
    let researchStudyJson = await getFhirJson(theM11ResearchStudyFoi, null, apiToken);
    let m11ReportBody = {
        status: "pending",
        m11ResearchStudyFoi: theM11ResearchStudyFoi,
        m11ResearchStudyResource: researchStudyJson,
        m11EligibilityCriteriaFoi: "",
        m11EligibilityCriteriaResource: "",
        m11ReportContainerFoi: "",
        m11ReportContainerResource: "",
        m11ReportSection01Foi: "",
        m11ReportSection01Resource: "",
        m11ReportSection02Foi: "",
        m11ReportSection02Resource: "",
        m11ReportSection03Foi: "",
        m11ReportSection03Resource: "",
        m11ReportSection04Foi: "",
        m11ReportSection04Resource: "",
        m11ReportSection05Foi: "",
        m11ReportSection05Resource: "",
        m11ReportSection06Foi: "",
        m11ReportSection06Resource: "",
        m11ReportSection07Foi: "",
        m11ReportSection07Resource: "",
        m11ReportSection08Foi: "",
        m11ReportSection08Resource: "",
        m11ReportSection09Foi: "",
        m11ReportSection09Resource: "",
        m11ReportSection10Foi: "",
        m11ReportSection10Resource: "",
        m11ReportSection11Foi: "",
        m11ReportSection11Resource: "",
        m11ReportSection12Foi: "",
        m11ReportSection12Resource: "",
        m11ReportSection13Foi: "",
        m11ReportSection13Resource: "",
        m11ReportSection14Foi: "",
        m11ReportSection14Resource: ""
    };
    if (researchStudyJson?.recruitment?.eligibility &&
        getIdFromReference(researchStudyJson.recruitment.eligibility)) {
        let groupFoi = getIdFromReference(researchStudyJson.recruitment.eligibility);
        if (groupFoi && !isNaN(groupFoi)) {
            m11ReportBody.m11EligibilityCriteriaFoi = groupFoi;
            m11ReportBody.m11EligibilityCriteriaResource = await getFhirJson(groupFoi, null, apiToken);
        }
    }
    let m11ReportContainerFoi = "";
    let m11ReportContainerResource = "";
    if (researchStudyJson?.relatesTo?.length > 0) {
        for (let relatesTo of researchStudyJson.relatesTo) {
            if (relatesTo.type?.coding?.[0]?.code === "supported-with" && relatesTo.type.text === "M11 Report" &&
                relatesTo.targetReference) {
                m11ReportContainerFoi = getIdFromReference(relatesTo.targetReference);
            }
        }
    }
    if (m11ReportContainerFoi && !isNaN(m11ReportContainerFoi)) {
        m11ReportBody.m11ReportContainerFoi = m11ReportContainerFoi;
        m11ReportContainerResource = await getFhirJson(m11ReportContainerFoi, null, apiToken);
        m11ReportBody.m11ReportContainerResource = m11ReportContainerResource;
    }
    if (m11ReportContainerResource && Object.keys(m11ReportContainerResource).length > 0 &&
        m11ReportContainerResource.section?.length > 1) {
        if (m11ReportContainerResource.section[1]?.entry?.length) {
            let m11ReportSection01Foi = getIdFromReference(m11ReportContainerResource.section[1].entry[0]);
            if (m11ReportSection01Foi && !isNaN(m11ReportSection01Foi)) {
                m11ReportBody.m11ReportSection01Foi = m11ReportSection01Foi;
                m11ReportBody.m11ReportSection01Resource = await getFhirJson(m11ReportSection01Foi, null, apiToken);
            }
        }
        if (m11ReportContainerResource.section[2]?.entry?.length) {
            let m11ReportSection02Foi = getIdFromReference(m11ReportContainerResource.section[2].entry[0]);
            if (m11ReportSection02Foi && !isNaN(m11ReportSection02Foi)) {
                m11ReportBody.m11ReportSection02Foi = m11ReportSection02Foi;
                m11ReportBody.m11ReportSection02Resource = await getFhirJson(m11ReportSection02Foi, null, apiToken);
            }
        }
        if (m11ReportContainerResource.section[3]?.entry?.length) {
            let m11ReportSection03Foi = getIdFromReference(m11ReportContainerResource.section[3].entry[0]);
            if (m11ReportSection03Foi && !isNaN(m11ReportSection03Foi)) {
                m11ReportBody.m11ReportSection03Foi = m11ReportSection03Foi;
                m11ReportBody.m11ReportSection03Resource = await getFhirJson(m11ReportSection03Foi, null, apiToken);
            }
        }
        if (m11ReportContainerResource.section[4]?.entry?.length) {
            let m11ReportSection04Foi = getIdFromReference(m11ReportContainerResource.section[4].entry[0]);
            if (m11ReportSection04Foi && !isNaN(m11ReportSection04Foi)) {
                m11ReportBody.m11ReportSection04Foi = m11ReportSection04Foi;
                m11ReportBody.m11ReportSection04Resource = await getFhirJson(m11ReportSection04Foi, null, apiToken);
            }
        }
        if (m11ReportContainerResource.section[5]?.entry?.length) {
            let m11ReportSection05Foi = getIdFromReference(m11ReportContainerResource.section[5].entry[0]);
            if (m11ReportSection05Foi && !isNaN(m11ReportSection05Foi)) {
                m11ReportBody.m11ReportSection05Foi = m11ReportSection05Foi;
                m11ReportBody.m11ReportSection05Resource = await getFhirJson(m11ReportSection05Foi, null, apiToken);
            }
        }
        if (m11ReportContainerResource.section[6]?.entry?.length) {
            let m11ReportSection06Foi = getIdFromReference(m11ReportContainerResource.section[6].entry[0]);
            if (m11ReportSection06Foi && !isNaN(m11ReportSection06Foi)) {
                m11ReportBody.m11ReportSection06Foi = m11ReportSection06Foi;
                m11ReportBody.m11ReportSection06Resource = await getFhirJson(m11ReportSection06Foi, null, apiToken);
            }
        }
        if (m11ReportContainerResource.section[7]?.entry?.length) {
            let m11ReportSection07Foi = getIdFromReference(m11ReportContainerResource.section[7].entry[0]);
            if (m11ReportSection07Foi && !isNaN(m11ReportSection07Foi)) {
                m11ReportBody.m11ReportSection07Foi = m11ReportSection07Foi;
                m11ReportBody.m11ReportSection07Resource = await getFhirJson(m11ReportSection07Foi, null, apiToken);
            }
        }
        if (m11ReportContainerResource.section[8]?.entry?.length) {
            let m11ReportSection08Foi = getIdFromReference(m11ReportContainerResource.section[8].entry[0]);
            if (m11ReportSection08Foi && !isNaN(m11ReportSection08Foi)) {
                m11ReportBody.m11ReportSection08Foi = m11ReportSection08Foi;
                m11ReportBody.m11ReportSection08Resource = await getFhirJson(m11ReportSection08Foi, null, apiToken);
            }
        }
        if (m11ReportContainerResource.section[9]?.entry?.length) {
            let m11ReportSection09Foi = getIdFromReference(m11ReportContainerResource.section[9].entry[0]);
            if (m11ReportSection09Foi && !isNaN(m11ReportSection09Foi)) {
                m11ReportBody.m11ReportSection09Foi = m11ReportSection09Foi;
                m11ReportBody.m11ReportSection09Resource = await getFhirJson(m11ReportSection09Foi, null, apiToken);
            }
        }
        if (m11ReportContainerResource.section[10]?.entry?.length) {
            let m11ReportSection10Foi = getIdFromReference(m11ReportContainerResource.section[10].entry[0]);
            if (m11ReportSection10Foi && !isNaN(m11ReportSection10Foi)) {
                m11ReportBody.m11ReportSection10Foi = m11ReportSection10Foi;
                m11ReportBody.m11ReportSection10Resource = await getFhirJson(m11ReportSection10Foi, null, apiToken);
            }
        }
        if (m11ReportContainerResource.section[11]?.entry?.length) {
            let m11ReportSection11Foi = getIdFromReference(m11ReportContainerResource.section[11].entry[0]);
            if (m11ReportSection11Foi && !isNaN(m11ReportSection11Foi)) {
                m11ReportBody.m11ReportSection11Foi = m11ReportSection11Foi;
                m11ReportBody.m11ReportSection11Resource = await getFhirJson(m11ReportSection11Foi, null, apiToken);
            }
        }
        if (m11ReportContainerResource.section[12]?.entry?.length) {
            let m11ReportSection12Foi = getIdFromReference(m11ReportContainerResource.section[12].entry[0]);
            if (m11ReportSection12Foi && !isNaN(m11ReportSection12Foi)) {
                m11ReportBody.m11ReportSection12Foi = m11ReportSection12Foi;
                m11ReportBody.m11ReportSection12Resource = await getFhirJson(m11ReportSection12Foi, null, apiToken);
            }
        }
        if (m11ReportContainerResource.section[13]?.entry?.length) {
            let m11ReportSection13Foi = getIdFromReference(m11ReportContainerResource.section[13].entry[0]);
            if (m11ReportSection13Foi && !isNaN(m11ReportSection13Foi)) {
                m11ReportBody.m11ReportSection13Foi = m11ReportSection13Foi;
                m11ReportBody.m11ReportSection13Resource = await getFhirJson(m11ReportSection13Foi, null, apiToken);
            }
        }
        if (m11ReportContainerResource.section[14]?.entry?.length) {
            let m11ReportSection14Foi = getIdFromReference(m11ReportContainerResource.section[14].entry[0]);
            if (m11ReportSection14Foi && !isNaN(m11ReportSection14Foi)) {
                m11ReportBody.m11ReportSection14Foi = m11ReportSection14Foi;
                m11ReportBody.m11ReportSection14Resource = await getFhirJson(m11ReportSection14Foi, null, apiToken);
            }
        }
    }
    dispatch(m11ReportCollectionLoaded(m11ReportBody));
}

const steps = [
    M11Step001SponsorDetails,
    M11Step002Identifiers,
    M11Step003TitlePageData,
    M11Step004Amendment,
    M11Step005CreateTitlePage,
    M11Step006Eligibility,
    M11Step007TrialPopulation,
    M11Step008FirstPrimaryObjective,
    M11Step009OtherPrimaryObjectives,
    M11Step010SecondaryObjectives,
    M11Step011ExploratoryObjectives,
    M11Step012ObjectivesAndEstimands,
    M11Step013EnterOverallDesign,
    M11Step014EnterOverallDesign2,
    M11Step015ProtocolSynopsisObjectives,
    M11Step016OverallDesign,
    M11Step017ProtocolSynopsis,
    M11Step018ProtocolSummary,
    M11Step019Introduction,
    M11Step020TrialDesign,
    M11Step021TrialInterventionPart1,
    M11Step022TrialInterventionPart2,
    M11Step023TrialInterventionPart3,
    M11Step024TrialInterventionPart4,
    M11Step025TrialInterventionPart5,
    M11Step026ParticipantDiscontinuation,
    M11Step027TrialAssessmentsPart1,
    M11Step028TrialAssessmentsPart2,
    M11Step029TrialAssessmentsPart3,
    M11Step030AdverseEventsDefinitions,
    M11Step031AdverseEventsProcedures,
    M11Step032CompleteAdverseEvents,
    M11Step033StatisticsPart1,
    M11Step034CompleteStatistics,
    M11Step035TrialOversightPart1,
    M11Step036TrialOversightPart2,
    M11Step037CompleteTrialOversight,
    M11Step038GatherAppendices,
    M11Step039Glossary,
    M11Step040References,
    M11Step041SupportingDetailsPart1,
    M11Step042PriorProtocolAmendments,
    M11Step043AdditionalAppendices,
    M11Step044ReportValidation,
    M11Step045CreateM11Report
];

//const stepMapping = { "1": ["0atitle"], "2": ["0atitle"], "3": ["0atitle"], "4": ["0atitle"], "5": ["0atitle"], "6": ["5"], "7": ["5"], "8": ["1", "3", "10"], "9": ["1", "3", "10"], "10": ["1", "3", "10"], "11": ["3", "10"], "12": ["3"], "13": [], "14": [], "15": ["1"], "16": ["1"], "17": ["1"], "18": ["1"], "19": ["2"], "20": ["4"], "21": ["6"], "22": ["6"], "23": ["6"], "24": ["6"], "25": ["6"], "26": ["7"], "27": ["8"], "28": ["8"], "29": ["8"], "30": ["9"], "31": ["9"], "32": ["9"], "33": ["10"], "34": ["10"], "35": ["11"], "36": ["11"], "37": ["11"], "38": [], "39": ["13"], "40": ["14"], "41": ["12"], "42": ["12"], "43": ["12"] };

const sectionMapping = { "0atitle": ["1", "2", "3", "4", "5"], "5": ["6", "7"], "10": ["8", "9", "10", "11", "33", "34"], "3": ["8", "9", "10", "11", "12"], "1": ["8", "9", "10", "15", "16", "17", "18"], "2": ["19"], "4": ["20"], "6": ["21", "22", "23", "24", "25"], "7": ["26"], "8": ["27", "28", "29"], "9": ["30", "31", "32"], "11": ["35", "36", "37"], "13": ["39"], "14": ["40"], "12": ["41", "42", "43"] };

const sectionTitleLookup = {
    "Title": "Title Page",
    "1": "Protocol Summary",
    "2": "Introduction",
    "3": "Trial Objectives and Estimands",
    "4": "Trial Design",
    "5": "Trial Population",
    "6": "Trial Intervention", // and Concomitant Therapy
    "7": "Participant Discontinuation",
    "8": "Trial Assessments",
    "9": "Adverse Events",
    "10": "Statistical Considerations",
    "11": "Trial Oversight",
    "12": "Supporting Details",
    "13": "Glossary",
    "14": "References"
};

const stepTitleLookup = {
    "1": "Sponsor Details",
    "2": "Identifiers",
    "3": "Titles, Products, and Phase",
    "4": "Enter Amendment Details",
    "5": "Complete Title Page",
    "6": "Study Eligibility",
    "7": "Complete the section",
    "8": "First Primary Objective",
    "9": "Additional Primary Objectives",
    "10": "Secondary Objectives",
    "11": "Exploratory Objectives",
    "12": "Complete the section",
    "13": "Overall Design Details part 1",
    "14": "Overall Design Details part 2",
    "15": "Objectives and Estimands Synopsis",
    "16": "Overall Design",
    "17": "Protocol Synopsis",
    "18": "Complete the section",
    "19": "Complete the section", //If The Section only has 1 step, then the step title doesn't show
    "20": "Complete the section",
    "21": "Add first part",
    "22": "Sections 6.1 to 6.5",
    "23": "Section 6.6 Preparation, Storage, Handling and Accountability",
    "24": "Section 6.7 Investigational Trial Intervention Assignment, Randomisation and Blinding",
    "25": "Complete the section",
    "26": "Complete the section",
    "27": "Trial Assessments and Procedures",
    "28": "Section 8.4 Safety Assessments and Procedures",
    "29": "Complete the section",
    "30": "Section 9.1 Definitions",
    "31": "Section 9.2 Collection and Reporting",
    "32": "Complete the section",
    "33": "Statistical Considerations",
    "34": "Complete the section",
    "35": "Part 1",
    "36": "Part 2",
    "37": "Complete the section",
    "38": "Gather Appendices",
    "39": "Complete the section",
    "40": "Complete the section",
    "41": "Supporting Details",
    "42": "Section 12.3 Prior Protocol Amendment(s)",
    "43": "Additional Appendices",
    "44": "",
    "45": ""
}

const sortedKeys = Object.keys(sectionMapping).sort((a, b) => {
    const numA = parseInt(a.replace(/\D/g, ""), 10) || 0;
    const numB = parseInt(b.replace(/\D/g, ""), 10) || 0;
    return numA - numB;
});

const FormattedSectionLabel = ({ keyname }) => {
    const key = keyname;
    if (!isNaN(key)) return <span>Section {key} <b>{sectionTitleLookup[key]}</b></span>;
    const cleaned = key.replace(/^[0-9]+[a-z]?/, "");
    //return `Section ${cleaned ? cleaned.charAt(0).toUpperCase() + cleaned.slice(1) : key}`;
    console.log(cleaned);
    return <b>{cleaned ? cleaned.charAt(0).toUpperCase() + cleaned.slice(1) + " Page" : "Section" + key}</b>;
};

const IndexHierarchy = ({ validationCheckState, setProgressMapModalState, stepCount, theM11ResearchStudyFoi, setGoToStepState }) => {
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const sectionFail = {};

    return <div style={{ maxWidth: "100%", padding: "8px 16px 16px 16px", fontFamily: "sans-serif" }}>
        <div
            style={{
                display: "grid",
                gridTemplateColumns: "repeat(auto-fill, minmax(240px, 1fr))",
                gap: "16px"
            }}
        >
            {sortedKeys.map((key) => {
                const steps = sectionMapping[key];
                sectionFail[key] = 0;
                return <div
                    key={key}
                    style={{
                        display: "flex",
                        flexDirection: "column",
                        border: "1px solid #e2e8f0",
                        borderRadius: "12px",
                        padding: "8px 16px 16px 16px",
                        backgroundColor: "#ffffff",
                        boxShadow: "0 1px 3px rgba(0,0,0,0.05)"
                    }}
                >
                    <div style={{ display: "flex", flexWrap: "wrap", flexDirection: "column", gap: "6px", order: 2 }}>

                        {steps.map((step, idx) => {
                            const fail = validationCheckState["step" + (step < 10 ? "0" : "") + step + "numberFailed"] > 0;
                            if (fail) {
                                sectionFail[key] += 1;
                            }
                            return <div style={{ display: "flex", verticalAlign: "center" }}>
                                <span style={{ paddingTop: "4px" }}>{fail ? "❌" : "✅"}</span>
                                <button
                                    key={idx}
                                    onClick={() => {
                                        setGoToStepState("");
                                        const url = "/m11report/" + theM11ResearchStudyFoi + "/step/" + (step);
                                        navigate(url);
                                        dispatch(m11StepCountUp());
                                        setProgressMapModalState(false);
                                    }}
                                    style={{
                                        display: "block",
                                        border: "none",
                                        backgroundColor: "#e7f4f6",
                                        color: "#1953cf",
                                        padding: "4px 10px",
                                        borderRadius: "6px",
                                        fontSize: "0.85rem",
                                        fontWeight: "500",
                                        cursor: "pointer",
                                        transition: "all 0.15s ease",
                                        textAlign: "left"
                                    }}
                                    onMouseEnter={(e) => {
                                        e.currentTarget.style.backgroundColor = "#1953cf";
                                        e.currentTarget.style.color = "#ffffff";
                                    }}
                                    onMouseLeave={(e) => {
                                        e.currentTarget.style.backgroundColor = "#e7f4f6";
                                        e.currentTarget.style.color = "#1953cf";
                                    }}
                                >
                                    Step {step}{steps.length > 1 ? <> {stepTitleLookup[step]}</> : ""}
                                </button>
                            </div>
                        }
                        )}
                    </div>
                    <div
                        style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            marginBottom: "12px",
                            borderBottom: "1px solid #f1f5f9",
                            paddingBottom: "8px",
                            order: 1
                        }}
                    >
                        <span style={{ fontWeight: "600", fontSize: "0.95rem", color: "#1e293b" }}>
                            <FormattedSectionLabel keyname={key} />{sectionFail[key] > 0 ? "❌" : "✅"}
                        </span>
                    </div>

                </div>;
            })}
        </div>
    </div>;
}

const ProgressMapModal = ({ progressMapModalState, setProgressMapModalState, stepCount, theM11ResearchStudyFoi, setGoToStepState, navigate, dispatch }) => {

    const apiToken = useSelector(selectCurrentUserApiToken);
    const [validationCheckState, setValidationCheckState] = useState({});

    useEffect(() => {
        if (theM11ResearchStudyFoi) {
            validateStep(apiToken, 44, theM11ResearchStudyFoi,
                setValidationCheckState)
        }
    }, [apiToken, theM11ResearchStudyFoi]);

    return <Modal
        style={{ width: "60%", margin: "16px", height: "90%", overflowY: "auto" }}
        dimmer={<Modal.Dimmer blurring style={{ backgroundColor: "#00000077" }} />}
        open={progressMapModalState}
        closeOnEscape
        closeOnDimmerClick
        onClose={() => { setProgressMapModalState(false); }}
        centered={false}
        content={<div style={{ whiteSpace: "pre-wrap" }}>
            <Button className="formButton negative"
                style={{ padding: "6px", position: "absolute", top: "6px", right: "6px", zIndex: 10 }} content="✖" title="Close"
                onClick={() => { setProgressMapModalState(false); }}
            />
            <Modal.Header style={{ padding: "6px 16px 0px 16px", color: "#AC3B61", textAlign: "center" }}>
                <h2>Progress Map</h2>
            </Modal.Header>

            {Object.keys(validationCheckState).length ?
                <>
                    <h3 style={{ margin: "0px", padding: "4px 0px 0px 24px" }}>
                        For the overall M11 Report {validationCheckState.numberOfChecks} issues checked. {validationCheckState.numberPassed} passed.
                        {validationCheckState.numberFailed ?
                            <span style={{ color: 'red' }}> {validationCheckState.numberFailed} FAILED</span>
                            :
                            <span> 0 failed</span>
                        }.
                    </h3>
                    <IndexHierarchy validationCheckState={validationCheckState} setProgressMapModalState={setProgressMapModalState} stepCount={stepCount} theM11ResearchStudyFoi={theM11ResearchStudyFoi} setGoToStepState={setGoToStepState} />
                    <div style={{ margin: "8px" }}>
                        <button
                            onClick={() => {
                                setGoToStepState("");
                                const url = "/m11report/" + theM11ResearchStudyFoi + "/step/45";
                                navigate(url);
                                dispatch(m11StepCountUp());
                                setProgressMapModalState(false);
                            }}
                            style={{
                                display: "block",
                                border: "none",
                                backgroundColor: "#e7f4f6",
                                color: "#1953cf",
                                padding: "4px 10px",
                                borderRadius: "6px",
                                fontSize: "0.85rem",
                                fontWeight: "500",
                                cursor: "pointer",
                                transition: "all 0.15s ease",
                                textAlign: "left"
                            }}
                            onMouseEnter={(e) => {
                                e.currentTarget.style.backgroundColor = "#1953cf";
                                e.currentTarget.style.color = "#ffffff";
                            }}
                            onMouseLeave={(e) => {
                                e.currentTarget.style.backgroundColor = "#e7f4f6";
                                e.currentTarget.style.color = "#1953cf";
                            }}
                        >
                            Go to Step 45: Generate the M11 Report
                        </button>
                    </div>
                </>
                :
                <Spinner />
            }
        </div>}
    />
}



const M11ReportAuthoringTool = ({ setM11ToolState }) => {

    let { foi, step } = useParams();
    foi = foi ? foi.replace(/(\/index\.html|[\/\.\s]|%20)+$/, "") : null;
    step = step ? parseInt(step.replace(/(\/index\.html|[\/\.\s]|%20)+$/, "")) : null;
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const apiToken = useSelector(selectCurrentUserApiToken);
    const stepCount = useSelector(selectM11StepCount);
    const m11User = useSelector(selectCurrentUserM11Use);
    //const foiFocus = useSelector(selectFoiFocus);
    const theM11ResearchStudyFoi = useSelector(selectM11ResearchStudyFoi);
    const m11ResearchStudyResource = useSelector(selectM11ResearchStudyResource);
    const scrollTimerRef = useRef(null);
    const activeChildRef = useRef(null);

    const [hasUnsavedChangesState, setHasUnsavedChangesState] = useState(false);
    const [goToStepState, setGoToStepState] = useState("");
    const [alertModalState, setAlertModalState] = useState({
        open: false, alertHistory: [], header: "", content: ""
    });
    const [titleState, setTitleState] = useState({
        "fullTitle": ""
    });
    const [openM11ValidationModalState, setOpenM11ValidationModalState] = useState(false);
    const [progressMapModalState, setProgressMapModalState] = useState(false);
    const [validationCheckState, setValidationCheckState] = useState({});

    const goToStep = () => {
        let step = parseInt(goToStepState.trim());
        if (Number.isInteger(step) && step <= m11HelperTextListLength && step > 0) {
            dispatch(goToM11Step(goToStepState)); //Is this needed?
            const url = "/m11report/" + theM11ResearchStudyFoi + "/step/" + step;
            navigate(url);
            setGoToStepState("");
        } else {
            alert("Invalid step number");
        }
    }

    const handleKeyUp = (event) => {
        if (event.key === 'Enter' && goToStepState) {
            goToStep();
            event.target.blur();
        }
    }

    const handleStepSave = async (confirmPrompt = true) => {
        if (!activeChildRef.current || !activeChildRef.current.unsavedChanges || !activeChildRef.current.saveAllChanges) {
            return true;
        }
        /*
            //Use a confirm modal instead
            const [confirmModalState, setConfirmModalState] = useState({
            open: false, header: "Save All Changes",
            content: "Do you want to save all changes you've made to the step before leaving? If not, please refresh the step.",
            runFunction: deleteAction, "functionParameters": null,
            saveFunction: null, buttonTextOkay: "Yes", buttonTextCancel: "No",
            buttonColorOkay: "green", buttonColorCancel: "red"
            });

            {confirmModalState.open &&
                <ConfirmModal confirmModalState={confirmModalState} setConfirmModalState={setConfirmModalState} />}
        */
        if (!confirmPrompt || window.confirm("You have unsaved changes, do you wish to save? If not, then please refresh the step.")) {
            await activeChildRef.current.saveAllChanges();
            validateStep(apiToken, step, theM11ResearchStudyFoi,
                setValidationCheckState);
            return true;
        } else {
            return false;
        }
    };

    const segment_scroll_storage_key = 'm11_' + (foi || "") + '_step_' + step + '_scroll';

    const setScrollRef = useCallback((nodeElement) => {
        //The weird thing is it seemed to be not working for refresh
        //restoreScrollPosition(nodeElement, segment_scroll_storage_key, 0); //Couldn't consistently get it to go to the top when switching steps, so it's not worth it to restore scroll position upon refresh if it means that glitch
        //Also commented it out because it'd remember your scroll position of when you were last on that step
    }, []);

    useEffect(() => {
        setM11ToolState(true);
    }, []);

    useEffect(() => {//For when you navigate to a page perhaps via back button and doesn't properly change FOI focus, a catch all
        if (!isNaN(foi) && foi !== theM11ResearchStudyFoi.toString()) {
            //dispatch(changeFoiFocus(foi));
            dispatch(m11ResearchStudyFoiChanged(foi));
        }
    }, [foi]);

    useEffect(() => {
        if (theM11ResearchStudyFoi && apiToken) {
            fetchTheSet(theM11ResearchStudyFoi, dispatch, apiToken);
        }
    }, [theM11ResearchStudyFoi, dispatch, apiToken]);

    useEffect(() => {
        if (theM11ResearchStudyFoi && step && step !== stepCount) {
            dispatch(goToM11Step(step));
            validateStep(apiToken, step, theM11ResearchStudyFoi,
                setValidationCheckState);
        }
    }, [theM11ResearchStudyFoi, step, stepCount, dispatch]);

    useEffect(() => {
        if (m11ResearchStudyResource?.title) {
            let startingTitleSet = {
                "fullTitle": m11ResearchStudyResource.title
            };
            setTitleState(startingTitleSet);
        }
    }, [m11ResearchStudyResource]);

    useEffect(() => {
        dispatch(changeTool("Computable Publishing®: M11 Report Authoring Tool"));
        let rafId;
        const check = () => {
            setHasUnsavedChangesState(!!activeChildRef.current?.unsavedChanges);
            rafId = requestAnimationFrame(check);
        };
        rafId = requestAnimationFrame(check);
        if (foi && !isNaN(foi)) {
            //dispatch(changeFoiFocus(foi));
            dispatch(m11ResearchStudyFoiChanged(foi));
        }
        return () => cancelAnimationFrame(rafId);
    }, []);


    useEffect(() => {
        if (goToStepState > 45) {
            setGoToStepState(prevState => prevState.slice(0, -1));
            alert("There are no steps above 45."); //It would be better as a modal
        }
    }, [goToStepState]);

    const ActiveStep = steps[stepCount - 1];

    let validationCheckFailed;
    if (step < 10) {
        validationCheckFailed = validationCheckState["step0" + step + "numberFailed"];
    } else {
        validationCheckFailed = validationCheckState["step" + step + "numberFailed"];
    }

    return <>
        <Ref innerRef={(nodeElement) => { setScrollRef(nodeElement); }}>
            <Segment
                className={`containerSegment maxRemainderOfPageSegment m11MaxRemainderOfPageSegment`}
                onScroll={(e) => { handleRememberScroll(e, segment_scroll_storage_key, scrollTimerRef, 140); }}
                onClick={(e) => {
                    e.stopPropagation(); // If the user clicks inside then it doesn't trigger the onClick of the parent, which is meant to make the whitespace outside clickable only
                }}
            >
                <div style={{ width: "400px", zIndex: 10, position: "fixed", margin: "0px", top: "54px", right: "0px" }}><FeedbackButton className="feedbackButton" /></div>
                <AlertModal alertModalState={alertModalState} setAlertModalState={setAlertModalState} />
                <ProgressMapModal progressMapModalState={progressMapModalState} setProgressMapModalState={setProgressMapModalState} stepCount={stepCount} theM11ResearchStudyFoi={theM11ResearchStudyFoi} setGoToStepState={setGoToStepState} navigate={navigate} dispatch={dispatch} />
                <div>
                    <div style={{ position: "absolute", top: "0px", left: "4px", color: "#4A4A4A" }}>Step {stepCount} / {m11HelperTextListLength}</div>
                    <h2 style={{ marginTop: "4px", paddingBottom: "8px" }}>M11 Report Creation for: {titleState.fullTitle}</h2>
                    {m11ResearchStudyResource && ActiveStep && (
                        <ActiveStep theResearchStudyFoi={theM11ResearchStudyFoi} ref={activeChildRef}
                            setAlertModalState={setAlertModalState} />
                    )}
                    {(stepCount < 1 || stepCount > 45) &&
                        <p>That Step count is not recognized.</p>
                    }
                    {hasUnsavedChangesState ?
                        <>
                            <Button className="formButton navigationButton"
                                style={{ width: "45%", margin: "0px" }}
                                positive
                                content="Save All Changes"
                                onClick={() => {
                                    handleStepSave(false);
                                }}
                            />
                            &nbsp;  &nbsp;  &nbsp;  &nbsp;
                            <Button className="formButton navigationButton"
                                style={{ width: "45%", margin: "0px" }}
                                positive
                                content="Save All Changes and Go To Next Step"
                                onClick={async () => {
                                    const proceed = await handleStepSave(false); //temporary, I want it to ask in a modal instead of a window.confirm()
                                    if (proceed) {
                                        const url = "/m11report/" + theM11ResearchStudyFoi + "/step/" + (stepCount + 1);
                                        navigate(url);
                                        dispatch(m11StepCountUp());
                                    }
                                }}
                            />
                        </>
                        :
                        <><br /><br /></>
                    }
                    {m11User === "sample" && <div>
                        <br />
                        <h2>You are Using the M11 Report Authoring Tool (Test Drive Version)</h2>
                        <p>The M11 Report Authoring Tool (Test Drive Version) will take you through a sampling of 19 of the 45 steps to create a complete M11 Report.</p>
                        <p>With the M11 Report Authoring Tool (Test Drive Version) you will be able to create an M11 Report with the Title Page, Section 1 Protocol Summary, Section 2 Introduction, Section 3.1.1 Primary Objective 1, Section 5 Trial Population, and Section 14 References, and then see how an M11 Report would be created with these sections completed.</p>
                        <p>Click the M11 tab on the right for guided steps through the M11 Report Authoring Tool (Test Drive Version).</p>
                        <Button className="formButton positive"
                            content="Use the Full M11 Report Authoring tool" compact
                            onClick={() => {
                                setAlertModalState(prevState => {
                                    return {
                                        ...prevState,
                                        "open": true,
                                        "header": "Use the M11 Report Authoring Tool (Professional Version)",
                                        "content": "Email support@computablepublishing.com with a request to use the M11 Report Authoring Tool."
                                    };
                                });
                                setM11useToPaid(apiToken);
                            }} />
                    </div>}
                </div>
            </Segment>
        </Ref>
        <Segment className={`containerSegment m11NavigationSegment`}>
            <div style={{ verticalAlign: "top" }}>
                <span>
                    <Button style={{ width: "140px", paddingTop: "6px", paddingBottom: "6px" }}
                        primary
                        className="formButton" content="🡸 Previous" /* ⮜ */
                        onClick={async () => {
                            const proceed = await handleStepSave(true); //temporary, I want it to ask in a modal instead of a window.confirm()
                            if (proceed) {
                                setGoToStepState("");
                                const url = "/m11report/" + theM11ResearchStudyFoi + "/step/" + (stepCount - 1);
                                navigate(url);
                                dispatch(m11StepCountDown());
                            }
                        }}
                        disabled={stepCount === 1} />
                    <span style={{ width: "80px", float: "center", paddingLeft: "6px" }} >
                        <div style={{ position: "relative", display: "inline-block", verticalAlign: "top", paddingTop: "2px" }}>
                            <span style={{ position: "relative", top: "2px" }}>Go to&nbsp;</span>
                            <TextField style={{ width: "100%", maxWidth: "60px", paddingLeft: "2px" }}
                                className="inputField"
                                type='number' inputMode='numeric' autoComplete='off'
                                size="small" variant='outlined'
                                sx={{ '& input:focus::placeholder': { opacity: 0 }, "& .MuiInputBase-input": { height: 8, padding: "0px !important" }, "& .MuiInputBase-root:not(.MuiInputBase-multiline, .Mui-error, .Mui-disabled) input": { padding: "8px 6px 8px 6px !important" } }}
                                placeholder={step ? step.toString() : ""} hiddenLabel
                                value={goToStepState ?? ""}
                                onWheel={handleWheel}
                                onKeyUp={handleKeyUp}
                                //onKeyDown={handleKeyDown}
                                //onInput={alertIfInvalidNumberEntry}
                                onChange={(e) => { setGoToStepState(e.target.value); }} />
                            {/* Include logic to make sure it's a valid number? */} {goToStepState &&
                                <Button className="formButton navigationButton"
                                    style={{ width: "26px", margin: "0px", padding: "5px 0px 4px 0px", position: "absolute", right: "-2px", top: "1px" }}
                                    positive
                                    content="➤"
                                    onClick={() => { goToStep(); }}
                                />}
                        </div>
                        &nbsp;&nbsp;
                    </span>
                    <Button style={{ width: "140px", paddingTop: "6px", paddingBottom: "6px" }}
                        primary
                        className="formButton" content="Next 🡺" /* ➤ */
                        onClick={async () => {
                            //It could be a separate button for "Save All Changes and Next"
                            const proceed = await handleStepSave(true); //temporary, I want it to ask in a modal instead of a window.confirm()
                            if (proceed) {
                                setGoToStepState("");
                                const url = "/m11report/" + theM11ResearchStudyFoi + "/step/" + (stepCount + 1);
                                navigate(url);
                                dispatch(m11StepCountUp());
                            }
                        }}
                        disabled={stepCount === m11HelperTextListLength} />
                    {theM11ResearchStudyFoi &&
                        <span>&nbsp;
                            <Button style={{ paddingTop: "6px", paddingBottom: "6px" }}
                                className={"formButton compact grey"}
                                content={"Progress Map"}
                                onClick={() => { setProgressMapModalState(true); }} />
                            <Button style={{ paddingTop: "6px", paddingBottom: "6px" }}
                                className={"formButton compact" + (validationCheckFailed ? " red" : " grey")}
                                content={"Validation Check for Step " + stepCount} /* FOI " + theM11ResearchStudyFoi */
                                onClick={() => { setOpenM11ValidationModalState(true); }} />
                        </span>
                    }
                </span>
                <span
                    style={{ backgroundColor: "#FFFFFF", padding: "4px" }}>
                    &nbsp;Step {stepCount} / {m11HelperTextListLength}
                </span>
                {openM11ValidationModalState &&
                    <M11ValidationModal openM11ValidationModalState={openM11ValidationModalState}
                        setOpenM11ValidationModalState={setOpenM11ValidationModalState}
                        stepCount={stepCount} theM11ResearchStudyFoi={theM11ResearchStudyFoi} />
                }
                {hasUnsavedChangesState && <>
                    &nbsp;
                    <Button className="formButton navigationButton"
                        style={{ width: "110px", margin: "0px", padding: "6px" }}
                        positive
                        content="Save Changes"
                        onClick={() => {
                            handleStepSave(false);
                        }}
                    />
                </>}
                {/*<span>&nbsp;{m11User === "paid" ? "Professional Version" : "Test Drive Version"}</span> TO DO Move Somewhere else*/}
            </div>
        </Segment>
    </>
};

export default M11ReportAuthoringTool;
export { fetchTheSet };